import { Injectable,EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class SellerProductListingService {

    constructor(private _http: HttpClient) { }

    getproductslisting(data) {
        return this._http.post(environment.api_url+'product/seller/search',data);
    }

}
